"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseDomain = void 0;
const parseDomain = (domain) => {
    const parts = domain.includes('.')
        ? domain.split('.')
        : [domain, undefined];
    return {
        tld: parts.pop(),
        domain: parts.join('')
    };
};
exports.parseDomain = parseDomain;
